<template>
  <v-form
    lazy-validation
    v-model="valid"
    @submit.prevent="submit"
    ref="form"
  >
      <v-container class="text-center">
        <h1>Recipe Verification</h1>
        <v-text-field
          filled
          data-cy="FormRecipeVerification-date"
          :label="$$t('date')"
          v-model="localRecipeVerification.date"
        />
        <v-text-field
          filled
          data-cy="FormRecipeVerification-farm"
          :label="$$t('farm')"
          v-model="localRecipeVerification.farm"
        />
        <v-select
          filled
          :items="['3-5', '6-12', '13-21', '22+']"
          data-cy="FormRecipeVerification-recipe"
          :label="$$t('recipe')"
          v-model="localRecipeVerification.recipe"
        />
        <v-row>
          <v-col cols="4">
            <v-text-field
              filled
              data-cy="FormRecipeVerification-brandingCode"
              :label="$$t('brandingCode')"
              v-model="localRecipeVerification.brandingCode"
            />
          </v-col>
          <v-col cols="4">
            <v-text-field
              filled
              data-cy="FormRecipeVerification-country"
              :label="$$t('country')"
              v-model="localRecipeVerification.country"
            />
          </v-col>
          <v-col cols="2">
            <v-text-field
              filled
              data-cy="FormRecipeVerification-asia"
              :label="$$t('asia')"
              v-model="localRecipeVerification.asia"
            />
          </v-col>
          <v-col cols="2">
            <v-text-field
              filled
              data-cy="FormRecipeVerification-other"
              :label="$$t('other')"
              v-model="localRecipeVerification.other"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <v-text-field
              filled
              data-cy="FormRecipeVerification-bestBefore"
              :label="$$t('bestBefore')"
              v-model="localRecipeVerification.bestBefore"
            />
          </v-col>
          <v-col cols="6">
            <v-text-field
              filled
              data-cy="FormRecipeVerification-canningCode"
              :label="$$t('canningCode')"
              v-model="localRecipeVerification.canningCode"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <v-text-field
              filled
              data-cy="FormRecipeVerification-product"
              :label="$$t('product')"
              v-model="localRecipeVerification.product"
            />
          </v-col>
          <v-col cols="4">
            <v-text-field
              filled
              data-cy="FormRecipeVerification-pouch"
              :label="$$t('pouch')"
              v-model="localRecipeVerification.pouch"
            />
          </v-col>
          <v-col cols="4">
            <v-text-field
              filled
              data-cy="FormRecipeVerification-can"
              :label="$$t('can')"
              v-model="localRecipeVerification.can"
            />
          </v-col>
        </v-row>
        <hr class="mb-5 mt-5" />
        <div :class="{ dimmed: localRecipeVerification.status }">
          <SignVerification role="Operator" :hideDate="true"
            v-model="localRecipeVerification.requestedBySignature" />
          <br />
          <v-row>
            <v-col cols="12" class="mb-10">
              <v-btn block color="success" @click="handover('Ready for NRCS')">Handover</v-btn>
            </v-col>
          </v-row>
        </div>
        <div :class="{ dimmed: localRecipeVerification.status !== 'Ready for NRCS' }">
          <SignVerification role="Nrcs" title="NRCS Inspector"
            v-model="localRecipeVerification.ncrsSignature"  />
          <br />
          <v-row>
            <v-col cols="12" class="mb-10">
              <v-btn block color="success" @click="handover('Completed')">Completed</v-btn>
            </v-col>
          </v-row>
        </div>
        <div class="d-flex justify-end mb-6">
          <v-btn color="default" outlined class="ml-4 btn-cancel" @click="cancel"
            data-cy="FormRecipeVerification-button-cancel">
            {{ $t('common.buttons.cancel') }}
          </v-btn>
          <v-btn color="primary" type="submit" class="ml-4" :loading="isSaving"
            data-cy="FormRecipeVerification-button-save">
              {{ $t('common.buttons.save') }}
            </v-btn>
        </div>
      </v-container>
  </v-form>
</template>

<script>
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import formChecklist from './formChecklist';
import SignVerification from './SignVerification.vue';

export default {
  name: 'FormRecipeVerification',
  module: 'RecipeVerification',
  components: {
    SignVerification,
  },
  mixins: [formChecklist, loading],
  props: {
    /**
    * Set the text box value. Default: undefined,
    */
    RecipeVerification: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      /**
      * Hold form validation state
      */
      valid: false,
      /**
      * Local value used for property localRecipeVerification
      */
      localRecipeVerification: {},
    };
  },
  watch: {
    RecipeVerification() {
      this.localRecipeVerification = this.RecipeVerification;
    },
  },
  created() {
    this.localRecipeVerification = this.RecipeVerification;
  },
  methods: {
    handover(status) {
      this.localRecipeVerification.status = status;
      this.$emit('save', this.localRecipeVerification);
    },
    /** Submit Form data trigger
     * @event save
     * @type {object}
     */
    submit() {
      // validate
      if (this.$refs.form.validate()) {
        this.$emit('save', this.localRecipeVerification);
        this.isSaving = true;
      }
    },
    /** Cancel form trigger
     * @event cancel
     */
    cancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<docs>
# FormRecipeVerification example

'''js
<FormRecipeVerification :RecipeVerification="RecipeVerification" />
'''
</docs>
